import { render } from "./P052.vue?vue&type=template&id=2a5c8791&scoped=true"
import script from "./P052.vue?vue&type=script&lang=js"
export * from "./P052.vue?vue&type=script&lang=js"

import "./P052.vue?vue&type=style&index=0&id=2a5c8791&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5c8791"]])

export default __exports__